function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#FB4A4A",
  d: "M13.829 12.087L9.185 3.698C8.943 3.261 8.5 3 8 3s-.942.261-1.185.698l-4.643 8.389c-.235.424-.229.927.018 1.345.246.417.682.666 1.166.666h9.288c.484 0 .92-.249 1.167-.666.245-.418.252-.92.018-1.345zM7.55 6.75a.45.45 0 11.9 0v3a.45.45 0 01-.9-.001v-3zM8 12.299a.6.6 0 11.001-1.201A.6.6 0 018 12.299z"
});

function SvgLoginWarninginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgLoginWarninginline;